import React, { useState } from "react";
import axios from "axios";
import { endOfDay, startOfDay, subDays } from 'date-fns';

// UMBRELLA
export const getRoamingComputers = async (apiUrl) => {
    const res = await axios(`${apiUrl}umbrella/roaming_computers`, {
        method: "get",
        withCredentials: true,
    });
    return res.data;
};

export const getTopThreat = async (apiUrl) => {
    const res = await axios(`${apiUrl}umbrella/top_threat/7/10`, {
        method: "get",
        withCredentials: true,
    });
    return res.data.data;
};

export const getTraficBlocked = async (apiUrl) => {
    const res = await axios(`${apiUrl}umbrella/blocked_traffic/7/10`, {
        method: "get",
        withCredentials: true,
    });
    return res.data.data;
};

//Securonix
export const getViolations = async (apiUrl, date) => {
    const today = endOfDay(new Date(), 23);
    const week = startOfDay(subDays(today, 7));

    const generationtime_from = new Date(today);
    const generationtime_to = new Date(week);

    const formatted_generationtime_to = `${(generationtime_from.getMonth() + 1).toString().padStart(2, '0')}/${generationtime_from.getDate().toString().padStart(2, '0')}/${generationtime_from.getFullYear()} 00:00:00`;
    const formatted_generationtime_from = `${(generationtime_to.getMonth() + 1).toString().padStart(2, '0')}/${generationtime_to.getDate().toString().padStart(2, '0')}/${generationtime_to.getFullYear()} 23:59:59`;

    const res = await axios(`${apiUrl}securonix/violations/${new Date(formatted_generationtime_from).getTime()}/${new Date(formatted_generationtime_to).getTime()}`, {
        method: "get",
        withCredentials: true
    });

    return res.data;
};

export const getThreats = async (apiUrl, date) => {
    const today = endOfDay(new Date(), 23);
    const week = startOfDay(subDays(today, 7));

    const res = await axios(`${apiUrl}securonix/threats/${new Date(week).getTime()}/${new Date(today).getTime()}`, {
        method: "get",
        withCredentials: true
    });
    return res.data;
};

//Palo Alto
export const getAllLicencesPaloAlto = async (apiUrl) => {
    const responses = await axios.all([
        axios.get(`${apiUrl}license/palo/`, {
            method: "GET",
            withCredentials: true,
        }),
        axios.get(`${apiUrl}eqptpalo/`, {
            method: "GET",
            withCredentials: true,
        }),
        axios.get(`${apiUrl}equipement/index`, {
            method: "GET",
            withCredentials: true,
        }),
    ]);

    const licences = responses[0].data;
    const eqpt = responses[1].data;
    const eqptFirewall = responses[2].data.filter((item) => item.famille && item.famille.nom === "FIREWALL");

    return { licences, eqpt, eqptFirewall };
};


export const getDashboardSentinelOne = async (apiUrl) => {
    const res = await axios(`${apiUrl}sentinelone/dashboard`, {
        method: "get",
        withCredentials: true
    })
    return res.data;
}

export const getDashboardIncidentsGraph = async (apiUrl) => {
    const res = await axios(`${apiUrl}incident`, {
        method: "GET",
        withCredentials: true,
    });
    return res.data;
}

export const getDashboardIncidentsListGraph = async (apiUrl) => {
    const res = await axios(`${apiUrl}incident/index`, {
        method: "GET",
        withCredentials: true,
    });

    return res.data.filter((incident) => incident.is_active === "1").sort((a, b) => new Date(b.createdon) - new Date(a.createdon));
};

export const getDashboardSecureEndpoint = async (apiUrl) => {
    const res = await axios(`${apiUrl}amp/index`, {
        method: "GET",
        withCredentials: true,
    });
    return res.data;
}

export const getDashboardSubscription = async (apiUrl) => {
    const res = await axios.get(`${apiUrl}subscription/index`, {
        method: "GET",
        withCredentials: true
    });
    return res.data;
}

export const getDashboardContractsCisco = async (apiUrl) => {
    const res = await axios.get(`${apiUrl}contract/byserial`, {
        method: "GET",
        withCredentials: true,
    });
    return res.data;
}

//Meraki 
export const getDashboardSummaryClientOrganisation = async (apiUrl) => {
    const res = await axios.get(`${apiUrl}meraki/summaryClients/organisation`, {
        method: "GET",
        withCredentials: true,
    });
    return res.data;
};

export const getDashboardNetworks = async (apiUrl) => {
    try {
        // Récupérer les réseaux Meraki
        const networksRes = await axios.get(`${apiUrl}meraki/networksMeraki`, {
            method: "GET",
            withCredentials: true
        });

        // Vérifier si les données des réseaux sont disponibles et sont un tableau
        if (!Array.isArray(networksRes.data)) {
            return [];
        }

        const networksMeraki = networksRes.data;

        // Récupérer tous les appareils et ajouter le nom du réseau
        const devicesRes = await axios.get(`${apiUrl}meraki/devices_statuses`, {
            withCredentials: true
        });

        // Vérifier si les données des appareils sont disponibles et sont un tableau
        if (!Array.isArray(devicesRes.data)) {
            return [];
        }

        const devicesWithNetworkName = devicesRes.data.map((item) => {
            const networkName = networksMeraki.find((network) => network.id === item.networkId);
            return {
                ...item,
                networkName: networkName ? networkName.name : 'Unknown Network'
            };
        });

        return devicesWithNetworkName;
    } catch (error) {
        console.error("Error fetching dashboard networks:", error);
        throw error; // Rejeter l'erreur pour que l'appelant puisse la gérer
    }
};

//Webex 
export const getDashboardDevices = async (apiUrl) => {
    const res = await axios.get(`${apiUrl}webex/devices_live`, {
        method: "GET",
        withCredentials: true,
    });
    return res.data;
}

//iot 
export const getIotDevices = async (apiUrl) => {
    try {
        const resIotWebex = await axios.get(`${apiUrl}webex/workspaces`, {
            withCredentials: true
        });
        const resIotMeraki = await axios.get(`${apiUrl}meraki/devices_status`, {
            withCredentials: true,
        });
        const iotWebex = resIotWebex.data;
        const iotMeraki = resIotMeraki.data.filter(device => device.productType === "camera");

        const iotWebexCount = iotWebex.items.length;
        const iotMerakiCount = iotMeraki.length;

        return {
            "Meraki": iotMerakiCount,
            "Webex": iotWebexCount
        };
    } catch (error) {
        return { "Meraki": 0, "Webex": 0 }; // Retourner des valeurs par défaut en cas d'erreur
    }
};